<div class="topHead">
    <a href="javascript:void(0);" class="adminBack" [routerLink]="['/user']"><img
            src="assets/images/admin/backarrow.png" /> Back to User Management</a>
    <!-- <div class="logout">
        <b>Pratibha Sharma</b>
        <a href="javascript:void(0);"><img src="assets/images/admin/power.png"/> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="centerWrap mt-4 pt-2">
    <div class="adminInnerHead">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="col-12 col-md-6" *ngIf="userDetail">
                    <div class="userDetail">
                        <h2>{{userDetail.first_name}} {{userDetail.last_name}}<small>Created on
                                {{userDetail.created_dttm | date:'d MMM, y'}}</small></h2>
                        <h3>{{userDetail.organisation_name}}</h3>
                        <!-- <div class="userDetailSocial">
                            <a href="mailto:userDetail.email"> <b><img src="assets/images/admin/mail.png" /></b>{{userDetail.userlist.email}}</a>
                            <a href="tel:+userDetail.phone"><b><img
                                        src="assets/images/admin/phone.svg" /></b>{{userDetail.phone}}</a>
                        </div>

                        <div class="userDetailSocial">
                            <a href="mailto:rajeevsrivastava@gmail.com"><b><img src="assets/images/admin/mail.png" /></b>{{userDetail.userList.email}}</a>
                            <a href="tel:+9197465 73721"><b><img src="assets/images/admin/phone.svg" /></b>{{userDetail.userList.phone}}</a>
                        </div> -->

                        <div class="userDetailSocial">
                            <a href="mailto:userDetail.email"><b><img src="assets/images/admin/mail.png" /></b>{{userDetail.email}}</a>
                            <a href="tel:+userDetail.phone"><b><img src="assets/images/admin/phone.svg" /></b>{{userDetail.phone}}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <ul class="customTab">
                    <li><a href="javascript:void(0);" [routerLink]="['/view_courses']" [queryParams]="{user_id:userID}"
                            class="active">VIEW COURSES</a> </li>
                    <li><a href="javascript:void(0);" [routerLink]="['/assign_courses']"
                            [queryParams]="{user_id:userID}">ASSIGN COURSES</a> </li>
                    <li><a href="javascript:void(0);" [routerLink]="['/user_edit']"
                            [queryParams]="{id:userID,type:'edit'}">EDIT</a> </li>
                    <li *ngIf="userDetail?.is_active==1" class="deactiveTab"><a href="javascript:void(0);" [routerLink]="['/user_deactive']"
                            [queryParams]="{user_id:userID}">DEACTIVATE</a> </li>
                    <li *ngIf="userDetail?.is_active==0" class="deactiveTab"><a href="javascript:void(0);" [routerLink]="['/user_deactive']"
                                [queryParams]="{user_id:userID}">ACTIVATE</a> </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="formHeading">
        <div class="row m-0">
            <div class="col-12 col-md-6">
                <h2>View Courses</h2>
                <p>View and track progress of all the courses assigned to this user.</p>
            </div>
            <div class="col-12 col-md-6">
                <a href="javascript:void(0);" *ngIf="is_download_enable" class="btn btn-primary btn-sm btn-border" (click)="alldownloadCartiCourse()" >
                    <span><img src="assets/images/admin/downloadarrow.png" /> Download All Certificates</span></a>
                <div class="commanSelect singleSelect d-none">
                    <mat-form-field appearance="fill">
                        <mat-label>Store</mat-label>
                        <mat-select>
                            <mat-option>None</mat-option>
                            <mat-option value="option1" selected>Store 1</mat-option>
                            <mat-option value="option2">Store 2</mat-option>
                            <mat-option value="option3">Store 3</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>


    <div class="tableWrap">
        <table matSort (matSortChange)="sortData($event)">
            <thead>
                <tr>
                    <th>
                        <div mat-sort-header="course_name"><b></b> Course Name</div>
                    </th>
                    <th>Status</th>
                    <th>% Completed</th>
                    <th>Time<br />Spent</th>
                    <th>Modules<br />Completed</th>
                    <th>Assessments<br />Passed</th>
                    <th>
                        <div class="reset_requestTh">Assessment<br />Reset Request <b><img
                                    src="assets/images/admin/frame_red.png" /></b></div>
                    </th>
                    <th>
                        <div class="reset_requestTh">Reset Request</div>
                    </th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr class="selectTrCourse" *ngFor="let values of userCourseList; let i = index">
                    <td>
                        <div class="courseTdWrap">
                            <a href="javascript:void(0);" [routerLink]="['/reset_request']" [queryParams]="{courseId:values.course_id,userId:values.user_id,type:'user'}">{{values.course_name}} </a><br>
                            <b>Assigned on {{values.created_dttm | date:'d MMM, y'}}</b>
                            <!-- <b>Assigned on {{values.assign_on | date:'d MMM, y'}}</b> -->
                        </div>
                    </td>
                    <td>
                        <div class="statusTd">
                            <!-- <span class="ongoing">{{values.status == 1 ? 'Not Started' : values.status == 2 ? 'Ongoing' : 'Completed'}}</span> -->
                            <span *ngIf="values.status == 1" class="statusTd red">Not Started</span>
                            <span *ngIf="values.status == 2" class="ongoing">ongoing</span>
                            <span *ngIf="values.status == 3" class="red">Completed</span>
                            <span class="d-block">Started on {{values.course_start_dttm | date:'d MMM, y'}}</span>
                            <span class="d-block">Last viewed on {{values.last_submodule_seen_time | date:'d MMM,
                                y'}}</span>
                        </div>
                    </td>
                    <td><b class="blue">{{values.percent_complete == null ? '0' : values.percent_complete}}%</b></td>
                    <td>{{ secondsToHms(values.total_time_spent)}}</td>
                    <td>{{values.no_of_modules_completed == null ? '0':
                        values.no_of_modules_completed}}/{{values.total_module}}</td>
                    <td>{{values.no_of_assessments_passed == null ? '0':
                        values.no_of_assessments_passed}}/{{values.total_assessement}}</td>
                    <td>
                        <span *ngIf="!values.assessment_id || (values.assessment_id && values.request_status != 1)">N/A</span> 
                        <div class="moduleWrap" *ngIf="values.assessment_id && values.request_status== 1">
                            <!-- <p *ngIf="values.module_name && values.submodule_name">Module 1 | SUbmodule 3</p>
                            <p *ngIf="values.module_name && !values.submodule_name">Module 1</p> -->
                            <div class="moduleChoues">
                                <a href="javascript:void(0);" class="moduleList"
                                    (click)="openAccept(AcceptContent, values)">
                                    <i><img src="assets/images/admin/done.png" /></i>Accept
                                </a>
                                <a href="javascript:void(0);" class="moduleList"
                                    (click)="openReject(RejectContent, values)">
                                    <i><img src="assets/images/admin/close_big.png" /></i>Reject
                                </a>
                            </div>
                            <a href="javascript:void(0);" class="btn-link" [routerLink]="['/reset_request']" [queryParams]="{courseId:values.course_id,userId:values.user_id,type:'user'}">View {{values.req_attempt}} Attempt request</a>
                        </div>
                    </td>
                    <td>{{values.reset_request}}</td>
                    <td>
                        <ul class="userActionBtn">
                            <!-- <li *ngIf="values.status == 1 || values.status == 2"><a href="javascript:void(0);" [routerLink]="['/view_courses']" [queryParams]="{user_id:values.user_id}"
                                    class="btn-link">DEASSIGN</a></li> -->
                            <li *ngIf="values.status == 1 || values.status == 2"><a href="javascript:void(0);" (click)="open(deassign,values.course_id)" class="btn-link">DEASSIGN</a></li>
                            <!-- <li><a href="javascript:void(0);" (click)="opens(deassign,values.user_id)" class="btn-link">DEASSIGN</a></li> -->
                            <li *ngIf="values.status == 3"><a href="javascript:void(0);"
                                        class="btn-link" (click)="downloadCartiCourse(values.course_name,values.course_completed_dttm)">DOWNLOAD CERTIFICATE</a></li>
                        </ul>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<ngx-spinner>
    <p style="color: white"> Loading... </p>
</ngx-spinner>

<ng-template #AcceptContent let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click');getUserCourseList(this.userID, this.searchText,this.order,this.order_by);">
                <span aria-hidden="true">&times;</span>
            </button>
            <h6>Accept Reset Request</h6>
            <p>You have approved the reset request.</p>

            <a href="javascript:void(0);" class="backPage ml-2 mr-2" (click)="modal.close('Close click');getUserCourseList(this.userID, this.searchText,this.order,this.order_by);">
                <span>Close</span>
            </a>
        </div>
    </div>
</ng-template>
<ng-template #deassign let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Deassign Course</h6>
                <p class="size18">Are you sure you want to deassign this Course?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="DeAssignUser(course_id)"
                    >Yes, DeAssign</a> 
            </div>
        </div>
    </div>
</ng-template>

<ng-template #RejectContent let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click'); getUserCourseList(this.userID, this.searchText,this.order,this.order_by);">
                <span aria-hidden="true">&times;</span>
            </button>
            <h6>Reject Reset Request</h6>

            <!-- <form [formGroup]="rejectForm">
                <div class="commanInput">
                    <mat-form-field class="example-full-width">
                        <mat-label>Remark</mat-label>
                        <input matInput formControlName="txtRemark" [ngClass]="{ 'is-invalid': submitted && f.txtRemark.errors }" autocomplete="off">
                    </mat-form-field> 
                    <div *ngIf="submitted && f.txtRemark.errors">
                        <span *ngIf="f.txtRemark.errors.required" class="text-mute text-danger errorText">This field is required</span>
                    </div>
                </div>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm btn-border" (click)="modal.close('Close click')"> <span>Close</span>
                </a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm ml-2 mr-2" (click)="onSubmit(rejectForm.value)">Submit</a>
              </form> -->
            <p>You have rejected the reset request.</p>

            <a href="javascript:void(0);" class="backPage ml-2 mr-2" (click)="modal.close('Close click'); getUserCourseList(this.userID, this.searchText,this.order,this.order_by);">
                <span>Close</span>
            </a>

        </div>
    </div>
</ng-template>